import React, { Component } from 'react'
import './styles.css'
import Icon from '../Icon'
import PropTypes from 'prop-types'

class CollapsibleTrigger extends Component {

  state = {
    open: true
  }

  componentDidMount () {
    let open = true
    if (this.props.closed === true) {
      open = false
    }
    this.setState({
      open: open
    })
    let app = this
    setTimeout(function () {
      app.handleCollapsible(open)
    }, 1000)
  }

  componentDidUpdate (prevProps) {

    if (this.props.closed !== prevProps.closed) {
      let open = true
      if (this.props.closed) {
        open = false
      }
      this.setState({
        open: open
      })
      this.handleCollapsible(open)
    }
  }

  toggleCollapsible = () => {
    if (this.state.open) {
      this.setState({
        open: false
      })
      this.handleCollapsible(false)
    } else {
      this.setState({
        open: true
      })
      this.handleCollapsible(true)
    }
  }

  handleCollapsible (open) {
    const elements = document.getElementsByClassName(this.props.for)

    if (open) {
      Array.from(elements).forEach((element) => {
        element.classList.remove('hideCollapsible')
      })
    } else {
      Array.from(elements).forEach((element) => {
        element.classList.add('hideCollapsible')
      })
    }
  }

  render () {
    if (this.props.children !== undefined) {
      if (this.props.openText !== undefined) {
        return (
          <div
            className={'CollapsibleTrigger CollapsibleTrigger' + (this.state.open === true ? 'Open' : 'Closed') + ' ' + this.props.className}
            onClick={this.toggleCollapsible}>
            {this.state.open === true &&
              <span>{this.props.openText}</span>
            }
            {this.state.open === false &&
              <span>{this.props.children}</span>
            }
          </div>
        )
      } else {
        return (
          <div
            className={'CollapsibleTrigger CollapsibleTrigger' + (this.state.open === true ? 'Open' : 'Closed') + ' ' + this.props.className}
            onClick={this.toggleCollapsible}>
            {this.props.children}
          </div>
        )
      }
    } else {
      return (
        <div className={'CollapsibleTrigger CollapsibleTrigger' + (this.state.open === true ? 'Open' : 'Closed')}
             onClick={this.toggleCollapsible}>
          {this.state.open === false &&
            <Icon size="small" type="arrow-blue-dn"/>
          }
          {this.state.open === true &&
            <Icon size="small" type="arrow-blue-up"/>
          }
        </div>
      )
    }
  }
}
CollapsibleTrigger.defaultProps = {
  closed: false
}
CollapsibleTrigger.propTypes = {
  for: PropTypes.string.isRequired,
  closed: PropTypes.bool,
  openText: PropTypes.string,
  children: PropTypes.any,
  className: PropTypes.string
}
export default CollapsibleTrigger
